import { Button } from '..';
import { useForm } from '../Form';
import type { ButtonProps } from '../Button';

export const SubmitButton: React.FC<ButtonProps> = ({ disabled, ...rest }) => {
  const { canSubmit } = useForm();

  return <Button {...rest} disabled={!canSubmit || disabled} />;
};
